import { renderErrorMessage } from './form-validation-error-message';
import { validateHandle } from './form-validation';

const inputsToValidate = document.querySelectorAll('[data-validators]');
const isInputsToValidate = () => inputsToValidate.length;

if (isInputsToValidate()) {
  inputsToValidate.forEach((input) => {
    input.addEventListener('input', () => {

      const validatorsData = JSON.parse(input.getAttribute("data-validators"));

      validatorsData.forEach((validator) => {

        const validatorMessage = input.parentNode.querySelector(".validator");
        if (validatorMessage !== null) validatorMessage.remove();
        input.closest(".f-text")?.classList.remove("--invalid")

        const { msg = "" } = validator;
        const inputValue = input.value;

        const result = validateHandle(validator, inputValue)

        if (!result) {
          input.after(renderErrorMessage(msg))
          input.closest(".f-text")?.classList.add("--invalid")
        }
      });
    });
  });
}


